import { Box, Card, LoadingOverlay } from '@mantine/core';
import { useTranslation } from 'locales';

interface DashboardChartLoaderProps {
  titleKey: string;
}

export const DashboardChartLoader = ({ titleKey }: DashboardChartLoaderProps) => {
  const { t } = useTranslation();

  return (
    <Card title={t(titleKey)}>
      <Box w="100%" h="285px">
        <LoadingOverlay visible />
      </Box>
    </Card>
  );
};
